<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="インターネットサイト設定参照(Type1、イントラネットFW)"
  >
    <template v-slot:body="{ cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row>
              <v-col class="d-flex flex-row ga-1 justify-end">
                <v-btn color="primary" @click="toChange">変更</v-btn>
              </v-col>
            </v-row>
            <v-tabs v-model="tabValue" grow hide-slider class="mt-3">
              <v-tab text="アドレス" value="address"></v-tab>
              <v-tab text="FQDN" value="fqdn"></v-tab>
            </v-tabs>
            <v-tabs-window v-model="tabValue">
              <!-- アドレスタブ-->
              <v-tabs-window-item value="address">
                <app-table
                  :fields="addressList.fields"
                  :items="addressList.items"
                  primary-key="ipAddressId"
                  :tr-class="() => undefined"
                  density="compact"
                >
                  <!-- アドレス名-->
                  <template #cell(ipAddressName)="data">
                    {{ data.value ? data.value : "-" }}
                  </template>
                  <!-- ゾーン配置-->
                  <template #cell(zoneId)="data">
                    {{ data.value ? "配置済" : "未配置" }}
                  </template>
                </app-table>
              </v-tabs-window-item>

              <!-- FQDNタブ-->
              <v-tabs-window-item value="fqdn">
                <app-table
                  :fields="fqdnList.fields"
                  :items="fqdnList.items"
                  primary-key="fqdnId"
                  :tr-class="() => undefined"
                  density="compact"
                >
                  <!-- FQDN名-->
                  <template #cell(fqdnName)="data">
                    {{ data.value ? data.value : "-" }}
                  </template>
                  <!-- ゾーン配置-->
                  <template #cell(zoneId)="data">
                    {{ data.value ? "配置済" : "未配置" }}
                  </template>
                </app-table>
              </v-tabs-window-item>
            </v-tabs-window>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import type {
  Type1InternetAddress,
  Type1InternetFQDN,
  Type1InternetInfo,
} from "@/apis/Type1SiteApi";
import { defineComponent } from "vue";
import type { AppTableHeader } from "@/components/AppTable.vue";
import { VueFinalModal } from "vue-final-modal";
import InternetSiteModify from "@/modals/type1/InternetSiteModify.vue";

export default defineComponent({
  name: "InternetSiteReference",
  props: {
    internetSiteZone: {
      type: Object as PropType<Type1InternetInfo>,
      required: true,
    },
  },
  data() {
    return {
      tabValue: "address",
      addressList: {
        fields: [
          {
            key: "ipAddressName",
            title: "アドレス名",
          },
          {
            key: "ipAddress",
            title: "アドレス",
            width: "200px",
          },
          {
            key: "zoneId",
            title: "ゾーン配置",
            width: "200px",
          },
        ] as AppTableHeader<Type1InternetAddress>[],
        items: [] as Type1InternetAddress[],
      },
      fqdnList: {
        fields: [
          {
            key: "fqdnName",
            title: "FQDN名",
          },
          {
            key: "fqdn",
            title: "FQDN",
            width: "200px",
          },
          {
            key: "zoneId",
            title: "ゾーン配置",
            width: "200px",
          },
        ] as AppTableHeader<Type1InternetFQDN>[],
        items: [] as Type1InternetFQDN[],
      },
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    /** 初期化機能 */
    load() {
      this.addressList.items = this.internetSiteZone.addressList;
      this.fqdnList.items = this.internetSiteZone.fqdnList;
    },
    /** 変更機能 */
    async toChange() {
      await this.$modal.show(InternetSiteModify, {
        internetSiteZone: this.internetSiteZone,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
